import { render, staticRenderFns } from "./TemplateColumnImage.vue?vue&type=template&id=c2fc4ade&scoped=true&"
import script from "./TemplateColumnImage.vue?vue&type=script&lang=js&"
export * from "./TemplateColumnImage.vue?vue&type=script&lang=js&"
import style0 from "./TemplateColumnImage.vue?vue&type=style&index=0&id=c2fc4ade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fc4ade",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2fc4ade')) {
      api.createRecord('c2fc4ade', component.options)
    } else {
      api.reload('c2fc4ade', component.options)
    }
    module.hot.accept("./TemplateColumnImage.vue?vue&type=template&id=c2fc4ade&scoped=true&", function () {
      api.rerender('c2fc4ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/ColumnContent/TemplateColumnImage.vue"
export default component.exports